export default __webpack_public_path__ + "static/media/mongo.62f6b1e4.png";